import axios from 'axios'

import { parseUrl } from './axios-interceptors/url-parser'
import { useErrorReponseInterceptor, useSuccessReponseInterceptor } from './axios-interceptors/useInterceptors'

// `axios.create()` snapshots defaults at call time, so we pass baseURL
// explicitly. Precedence:
//   1. `VITE_API_URL` if defined in .env.local — empty string is
//      meaningful: it means "same-origin", which together with the Vite
//      server.proxy config gives us proxied-to-staging dev mode without
//      cross-origin cookies.
//   2. `window.config.api_url` from /api/bootstrap/user (default prod).
//   3. Empty string → same-origin relative paths.
const apiBaseURL = import.meta.env?.VITE_API_URL !== undefined
  ? import.meta.env.VITE_API_URL
  : (window.config?.api_url || '')

axios.interceptors.response.use(
  useSuccessReponseInterceptor,
  useErrorReponseInterceptor,
)

const axiosInstance = axios.create({
  baseURL: apiBaseURL,
  withCredentials: Boolean(apiBaseURL),
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.response.use(
  useSuccessReponseInterceptor,
  useErrorReponseInterceptor,
)

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone
    return parseUrl(config)
  },
  (error) => Promise.reject(error),
)

export default axiosInstance
